import { gql } from "@apollo/client";
import { LibraryItemDetailPage_LibraryItemFragment } from "../LibraryItemDetailPageContainer.generated";
import usePathBuilderContentPermission from "@src/components/libraryItemDetailPages/module/hooks/usePathBuilderContentPermission";
import { LibraryItemContentPermissionsFragment } from "./useLibraryItemPermissions.generated";
import { useContentPermissionsQuery } from "./useContentPermissions.generated";

const useLibraryItemPermissions = (
  libraryItem?: LibraryItemDetailPage_LibraryItemFragment | null,
): LibraryItemContentPermissionsFragment | undefined => {
  const pathBuilderVersionPermissions = usePathBuilderContentPermission();
  const { data } = useContentPermissionsQuery({
    variables: {
      courseId: libraryItem?.course?.id,
      pathId: libraryItem?.path?.id,
      skillId: libraryItem?.skill?.id,
      trainingResourceId: libraryItem?.trainingResource?.id,
    },
    skip:
      !libraryItem?.course?.id &&
      !libraryItem?.path?.id &&
      !libraryItem?.skill?.id &&
      !libraryItem?.trainingResource?.id,
    fetchPolicy: "cache-first",
  });
  return (
    // If in the path detail page, path permissions always take priority
    pathBuilderVersionPermissions || data?.ContentPermissions || undefined
  );
};

gql`
  query LibraryItemContentPermissions(
    $courseId: Int
    $pathId: Int
    $skillId: Int
    $trainingResourceId: UUID
  ) {
    ContentPermissions: AdminContentPermissions(
      courseId: $courseId
      pathId: $pathId
      skillId: $skillId
      trainingResourceId: $trainingResourceId
    ) {
      ...ContentPermissions
    }
  }

  fragment LibraryItemContentPermissions on ContentPermissions {
    hasEditContentPermission
    hasPublishPermission
    hasCommentPermission
    hasShareWithIndividualsPermission
    hasEditAdminAndManagerSharingPermission
  }
`;

export default useLibraryItemPermissions;
